import { Component, EventEmitter, Input, Inject, AfterViewInit, Output, ViewChild, DOCUMENT } from '@angular/core';
import { environment } from '../environments/environment';

import { GenericService } from '../common/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataService } from '../common/data.service';
import { CustomPropertyData, CustomPropertyConfig, FileDetail, CustomPropertyValue, ItemSource } from './CustomProperty.model';
import { HttpClient, HttpResponse, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LazyLoadingService } from '../common/lazyloading';
import { catchError, map } from 'rxjs/operators';
import { UtilityService } from '../common/utility.service';
import { Constants } from '../common/constants';
import { ConfirmationComponent, ConfirmationType } from '../common/Controls/Confirmation/confirmation.component';






@Component({
    selector: 'app-CustomProperty-Application',
    templateUrl: './CustomProperty.component.html',
    styleUrls: ['./CustomProperty.component.css'],
    standalone: false
})
///Component can be integrated with parent component
export class CustomPropertyComponent implements AfterViewInit {

  private documentURL: string;
  private urlAarray: string[];
  private baseURL: string;
  private hostname: string;
  public getApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public userName: string;
  public __bIsLoadingVisible: boolean = false;
   richTextBoxContentChanged: boolean = false;

  //imput values
  @Input()
  __sEntityGroupName: string = "";
  @Input() __bIsDefaultValueChanged: boolean;
  @Output() defaultValueChanged = new EventEmitter<boolean>();
  @ViewChild(ConfirmationComponent) __oConfirmationComponent: ConfirmationComponent;

  @Input()
  public __oSystemSetting: any[] = [{}];
  ;
  @Input()
  public __oEntity: any = {};
  @Input()
  public __oTradingEntities: any[] = [];

  /// Class level variables

  public __oCustomPropertyData: CustomPropertyData[] = [];
  public __oCustomPropertySegregatedData: CustomPropertyData[] = [];
  private __oCustomPropertyConfig: CustomPropertyConfig = null;
  private __oCustomPropertyValue: CustomPropertyValue[] = null;
  private __oFroalaEditorOptions: Object = {};
  public __sPortalDateFormat: string;

  todayButton: any;
  constructor(@Inject(DOCUMENT) private document: any, public _postDataService: GenericService, private route: ActivatedRoute, private router: Router,
    private data: DataService, private http: HttpClient, private datePipe: DatePipe, private lazyLoadingService: LazyLoadingService, private __oUtilityService: UtilityService) {

    this._postDataService.getDataByObservable(this.getApiUrl + "api/CommonBase/FroalaKey").subscribe((data) => {
      if (data != null) {
        this.__oFroalaEditorOptions = {
          key: data,attribution: false,

          heightMin: 250,
          heightMax: 500,
          width: 800,
          charCounterMax: 20000,
          charCounterCount: false,
          tableResizer: true,
          imageResize: true,
          useClasses: false,
          placeholderText: 'Enter Details ...',
          // Set the image upload parameter.
          imageUploadParam: 'image_param',

          // Set the image upload URL.
          imageUploadURL: 'assets/upload_image',

          // Additional upload params.
          imageUploadParams: { id: 'my_editor' },

          // Set request type.
          imageUploadMethod: 'POST',

          // Set max image size to 5MB.
          imageMaxSize: 5 * 1024 * 1024,

          // Allow to upload PNG and JPG.
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
          toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'textColor', 'backgroundColor', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'undo', 'redo'],
          //toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertFile', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'help', 'html', '|', 'undo', 'redo'],
          colorsBackground: [
            '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
            '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
          ],
          colorsStep: 6,
          colorsText: [
            '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
            '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
          ],
          pluginsEnabled: ['align', 'colors', 'draggable', 'fontFamily', 'fontSize', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'print', 'quote', 'image', 'table', 'specialCharacters', 'url', 'wordPaste'],
          events: {
            'froalaEditor.initialized': function (editor: any) {

            },
            'froalaEditor.image.beforeUpload': (e: any, editor: any, images: any) => {
              //Your code
              if (images.length) {
                // Create a File Reader.
                const reader = new FileReader();
                // Set the reader to insert images when they are loaded.
                reader.onload = (ev) => {
                  const result = ev.target['result'];
                  editor.image.insert(result, null, null, editor.image.get());
                };
                // Read image as base64.
                reader.readAsDataURL(images[0]);
              }
              // Stop default upload chain.
              return false;
            },
            'froalaEditor.mousedown': (e, editor, mousedownEvent) => {

            },
            'froalaEditor.mouseup': (e, editor, mouseupEvent) => {

            },
            'contentChanged': () => {
              this.defaultValueChanged.emit(true);
              this.richTextBoxContentChanged = true;
            },

          }
        }
      }
    });



  }

  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {

    //To handle  Date format in Portal
    this.__sPortalDateFormat = sessionStorage.getItem('PortalDateFormat');
    this.data.portalDateFormat$.subscribe(format => {
      if (format != null)
        this.__sPortalDateFormat = format;
    });

    this._postDataService.getDataByObservable(this.getApiUrl + "api/CustomProperty/GetCustomPropertyConfig/").subscribe((Data) => {
      if (Data != null) {
        this.__oCustomPropertyConfig = Data[0];
        if( this.__oCustomPropertyConfig?.FilePath!=null &&  this.__oCustomPropertyConfig?.FilePath!='')
          {
            this.__oCustomPropertyConfig.FilePath=this.__oUtilityService.DecryptStringAES(this.__oCustomPropertyConfig.FilePath, Constants.EXTERNALSOURCE_AESKEY)
          }
      }

    });
  }

  onValueChanged(event) {
    if (event.event) {
      this.defaultValueChanged.emit(true);
    }
  }


  /// component public methods can be called from parent component


  PopulateCustomProperty(lDataInstanceId: number) {
    this.__oCustomPropertyData = [];
    this.__oCustomPropertyValue = [];
    this.richTextBoxContentChanged = false;

    if (lDataInstanceId > 0) {
      this.__bIsLoadingVisible = true;
      this._postDataService.getDataByObservable(this.getApiUrl + "api/CustomProperty/GetCustomPropertyData/" + this.__sEntityGroupName + "/" + lDataInstanceId.toString()).subscribe((Data) => {
        this.__bIsLoadingVisible = false;
        if (Data != null) {
          if (this.__oSystemSetting && this.__oSystemSetting.length > 0 && this.__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && this.__oEntity) {
            this.__oCustomPropertySegregatedData = Data;
            this.__oCustomPropertyData = Data.filter(x => (x.lTradingEntityId === this.__oEntity.lTradingEntityId));
          }
          else {
            this.__oCustomPropertyData = Data;
          }
          this.formSources(lDataInstanceId);
        }
      });
    }
  }

  //forms control data sources
  private formSources(lDataInstanceId: number) {
    for (let oCustomPropertyData of this.__oCustomPropertyData) {
      if (oCustomPropertyData.CustomPropertyDataType == 'File Chooser') {
        oCustomPropertyData.FileDetail = [];

        if (oCustomPropertyData.Value != '' && oCustomPropertyData.Value != null) {
        var filepaths=this.__oUtilityService.DecryptStringAES(oCustomPropertyData.Value, Constants.EXTERNALSOURCE_AESKEY);
        if(filepaths != '' && filepaths != "'" && filepaths!=null)
          {
            oCustomPropertyData.Value=filepaths;
          }
          let AllFiles: string[] = oCustomPropertyData.Value.split(",");

          for (let FileIndex in AllFiles) {
            let oFileDetail: FileDetail = null;
            oFileDetail = new FileDetail();

            oFileDetail.lCustomPropertyDataId = oCustomPropertyData.lCustomPropertyDataId;
            oFileDetail.FilePath = AllFiles[FileIndex];
            oFileDetail.FileName = AllFiles[FileIndex].split(/[/\\]/).pop();
            oCustomPropertyData.FileDetail.push(oFileDetail);
          }
        }
      }
      if (oCustomPropertyData.CustomPropertyDataType == 'Multi Select Combo Box') {
        oCustomPropertyData.MultiSelectedItems = [];

        if (oCustomPropertyData.Value != null) {
          let sDataValue: string = oCustomPropertyData.Value;
          let oMultiSelectItems: string[] = sDataValue.split(',');

          for (let oItem of oMultiSelectItems) {
            oCustomPropertyData.MultiSelectedItems.push(oItem.replace(/commma/g, ','));
          }
        }
      }
      if (oCustomPropertyData.CustomPropertyDataType == 'True/False') {
        let sDataValue: string = oCustomPropertyData.Value;

        if (sDataValue != null) {
          if (sDataValue.toLowerCase() == 'true') {
            oCustomPropertyData.Value = true;
          }
          else {
            oCustomPropertyData.Value = false;
          }
        }
        else {
          oCustomPropertyData.Value = false;
        }
      }
      if (oCustomPropertyData.CustomPropertyDataType == 'Numeric' || oCustomPropertyData.CustomPropertyDataType == 'Money' && oCustomPropertyData.Value != null) {
        oCustomPropertyData.Value = Number(oCustomPropertyData.Value);
      }
      if (oCustomPropertyData.CustomPropertyDataType == 'Uri') {
        oCustomPropertyData.ReferenceDataURLVisible = 1;
        oCustomPropertyData.ReferenceDataTextBoxVisible = 0;
      }
      oCustomPropertyData.AddTodayButton = {
        text: "Today",
        type: "default",
        onClick: (e: any) => {
          this.AddTodayButtonClicked(e, oCustomPropertyData.CustomProperty);
        }
      };
    }

    this._postDataService.getDataByObservable(this.getApiUrl + "api/CustomProperty/GetCustomPropertyDataItemSource/" + this.__sEntityGroupName + "/" + lDataInstanceId.toString()).subscribe((Data) => {
      if (Data != null) {
        let oCustomPropertyDataWithItemSource: CustomPropertyData[] = Data;

        for (var oCPDWI of oCustomPropertyDataWithItemSource) {
          let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == oCPDWI.lCustomPropertyDataId);

          if (oCustomPropertyData != null) {
            oCPDWI.ItemSource = !oCPDWI.ItemSource ? "[]" : oCPDWI.ItemSource;
            oCustomPropertyData.ItemSource = JSON.parse(oCPDWI.ItemSource);
          }

        }

      }

    });
  }
  getCustomPropertyCollection(): CustomPropertyValue[] {
    this.__oCustomPropertyValue = [];
    for (var oCPD of this.__oCustomPropertyData.filter(x => (x.EntityState != null && x.EntityState != undefined) || x.CustomPropertyDataType == 'RichTextBox')) {
      let oCustomPropertyValue: CustomPropertyValue = new CustomPropertyValue();

      oCustomPropertyValue.lCustomPropertyValueId = oCPD.lCustomPropertyValueId ?? 0;
      oCustomPropertyValue.lDataInstanceId = oCPD.lDataInstanceId;
      oCustomPropertyValue.lCustomPropertyId = oCPD.lCustomPropertyId;
      oCustomPropertyValue.lTradingEntityId = oCPD.lTradingEntityId;

      if (oCPD.CustomPropertyDataType == 'Multi Select Combo Box') {
        if (oCPD.MultiSelectedItems != null) {
          let oMultiselectedItems: string[] = [];

          for (let oItem of oCPD.MultiSelectedItems) {
            let sItem: string = oItem;
            oMultiselectedItems.push(sItem.replace(/,/g, 'commma'))
          }

          oCustomPropertyValue.Value = oMultiselectedItems.join(',');
        }
      }
      else if (oCPD.CustomPropertyDataType == 'Date') {
        oCustomPropertyValue.Value = oCPD.Value ? this.datePipe.transform(oCPD.Value, 'yyyy-MM-dd').toString() : oCPD.Value;
      } else if (oCPD.CustomPropertyDataType == 'File Chooser' && oCPD.Value!='' && oCPD.Value!=null) {
        oCustomPropertyValue.Value = this.__oUtilityService.EncryptStringAES(oCPD.Value, Constants.EXTERNALSOURCE_AESKEY).toString();
      }
      else {
        oCustomPropertyValue.Value = oCPD.Value?.toString();
      }
      oCustomPropertyValue.EntityState = oCPD.EntityState;

      if (oCPD.CustomPropertyDataType == 'RichTextBox') {
       if (oCPD.lCustomPropertyValueId > 0 && this.richTextBoxContentChanged) {
          oCustomPropertyValue.EntityState = 2;
        }
         else if (this.richTextBoxContentChanged){
          oCustomPropertyValue.EntityState = 1;
        }
      }

      this.__oCustomPropertyValue.push(oCustomPropertyValue);

    }

    return this.__oCustomPropertyValue;
  }

  onEditorChange(item) {
    this.__oCustomPropertyData.find(x => x.lCustomPropertyId === item.lCustomPropertyId).EntityState = 2;
  }

  /// Events

  private TextAreaOnChange(lCustomPropertyDataId: any, event?: any, selection?: string, item?: any) {
    if(item) {
      item.Value = event.value;
    }
    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);
    if (event.event || (event && selection == 'autocomplete')) {
      this.defaultValueChanged.emit(true);
    }
    if (selection == 'multiselect') {
      if (event.value?.length !== event.previousValue?.length) {
        if (oCustomPropertyData.lCustomPropertyValueId > 0) {
          oCustomPropertyData.EntityState = 2;
        }
        else {
          oCustomPropertyData.EntityState = 1;
        }
        this.defaultValueChanged.emit(true);
      } else {
        for(let i = 0; i < event.value.length; i++) {
          if(event.value[i] != event.previousValue[i]) {
            if (oCustomPropertyData.lCustomPropertyValueId > 0) {
              oCustomPropertyData.EntityState = 2;
            }
            else {
              oCustomPropertyData.EntityState = 1;
            }
            this.defaultValueChanged.emit(true);
            break;
          }
        }
      }
    }
    if (selection == 'DropDown') {
      if (event.event && oCustomPropertyData != null) {
        if (oCustomPropertyData.lCustomPropertyValueId > 0) {
          oCustomPropertyData.EntityState = 2;
        }
        else {
          oCustomPropertyData.EntityState = 1;
        }
      }
    } else if (selection == 'autocomplete') {
      const validValues = item?.ItemSource.map(x => x.DisplayMember);
      if (event.event && oCustomPropertyData != null && (selection == 'autocomplete' && (validValues.includes(event.value) || !event.value))) {
        if (oCustomPropertyData.lCustomPropertyValueId > 0) {
          oCustomPropertyData.EntityState = 2;
        }
        else {
          oCustomPropertyData.EntityState = 1;
        }
      }
    } else if (oCustomPropertyData != null) {
      if (oCustomPropertyData.lCustomPropertyValueId > 0) {
        oCustomPropertyData.EntityState = 2;
      }
      else {
        oCustomPropertyData.EntityState = 1;
      }
    }
    if (this.__oSystemSetting && this.__oSystemSetting.length > 0 && this.__oSystemSetting[0].IsCounterpartySegregatedByTradingEntity && this.__oEntity && this.__oEntity.lTradingEntityId) {
      oCustomPropertyData.lTradingEntityId = this.__oEntity.lTradingEntityId;
    }
  }

  public onKeyPressNumberBoxState(e: any, lCustomPropertyDataId: any) {

    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);

    if (e.event.key == 'm' || e.event.key == "M") {
      oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
    }
    else if (e.event.key == "b" || e.event.key == "B") {
      oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
    }
    else if (e.event.key == "k" || e.event.key == "K") {
      oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
    }
    else if (e.event.key == "h" || e.event.key == "H") {
      oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
    }
    else if (e.event.key == "t" || e.event.key == "T") {
      oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
    }

  }

  private GetDataForACB(lCustomPropertyDataId: any, lCustomPropertyId: any) {

    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);

    let oItemSource: ItemSource[] = oCustomPropertyData.ItemSource;

    if (oCustomPropertyData.Value == null) {
      oCustomPropertyData.EntityState = 2;
    }
    if (oItemSource != null && oItemSource != undefined && oItemSource.length > 0) {
      if (oItemSource.find(x => x.DisplayMember == oCustomPropertyData.Value) != null) {
        return;
      }
    }
    if (oCustomPropertyData.Value != null && oCustomPropertyData.Value != '') {
      this._postDataService.getDataByPromise(this.getApiUrl + "api/CustomProperty/GetItemSourceForAutoCompleteBox/" + lCustomPropertyId + "/" + oCustomPropertyData.Value).then((Data) => {

        if (Data != null) {

          //for (let oCurrentInstanceWithItemSource of Data)
          {

            if (oCustomPropertyData != null) {

              try {
                oCustomPropertyData.ItemSource = JSON.parse(Data);
              }
              catch
              {
                console.log(Data);
              }

              if (oCustomPropertyData.ItemSource != undefined && oCustomPropertyData.ItemSource.length > 0) {
                oCustomPropertyData.opened = true;
              }


            }

          }
        }

      });
    }
  }

  private fileUpload(event: any, lCustomPropertyDataId: any) {

    let fileList: FileList = event.target.files;
    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);
    let oCustomPropertyComponent: any = this;

    this.defaultValueChanged.emit(true);

    if (fileList.length > 0) {

      let formData: FormData = new FormData();

      for (let fileIndex in fileList) {
        if (fileIndex.toUpperCase() != 'LENGTH' && fileIndex.toUpperCase() != 'ITEM') {

          let file: File = fileList[fileIndex];

          if (file.name.includes(",")) {
            alert("File name with ',' is restricted.");
            return;
          }

          if (this.__oCustomPropertyConfig != null && this.__oCustomPropertyConfig.AllowedFileTypes != null) {

            let AllowedFileTypes: string[] = this.__oCustomPropertyConfig.AllowedFileTypes.toUpperCase().split(",");
            let sFileExtension: string = file.name.substring(file.name.lastIndexOf(".") + 1);

            if (AllowedFileTypes.indexOf(sFileExtension.toUpperCase(), 0) == -1) {
              alert("File type " + sFileExtension + " is restricted.");
              return;
            }
            else {
              formData.append('Files', file, file.name);
            }

          }
          else {
            alert("Restricted file types are not configured.");
            return;
          }
        }
      }

      let sFilePaths: string[] = [];

      formData.append('lCustomPropertyDataId', lCustomPropertyDataId.toString());
      let headers = new Headers()
      let options = new Object({ headers: headers, withCredentials: true });
      //FB 6060 SSO Integration
      //if (environment.SSOEnabled) {
      //  options = null;
      //  options = new Object({ headers: headers });
      //}
      let apiUrl1 = this.getApiUrl + "api/CustomProperty/UploadFile";

      this.http.post(apiUrl1, formData, options)
          .pipe(map(res => JSON.parse(JSON.stringify(res)), catchError(error => throwError(error))))
        .subscribe(
          data => sFilePaths = this.__oUtilityService.DecryptStringAES(data, Constants.EXTERNALSOURCE_AESKEY).split(','),
          error => {
            let errorMessage: string = error?.error;
            if (errorMessage) {
              if(!errorMessage.includes('Please see the event logs for more information'))
                {
                  errorMessage = errorMessage.replace(/\./, '<br/><br/>');
                  errorMessage = errorMessage.replace(/,/g, '<br/>');
                  errorMessage += "<br/></br>Please re-upload all other files.";
                }
              this.__oConfirmationComponent.show(ConfirmationType.Error, errorMessage, "File upload error", "Ok", "", false);
            }
          },
          () => {

            for (let fileIndex in sFilePaths) {
              if (oCustomPropertyData.Value == null || oCustomPropertyData.Value == '') {
                oCustomPropertyData.Value = sFilePaths[fileIndex];
              }
              else {
                oCustomPropertyData.Value = oCustomPropertyData.Value + "," + sFilePaths[fileIndex];
              }

            }


            oCustomPropertyData.FileDetail = [];

            let AllFiles: string[] = oCustomPropertyData.Value.split(",");

            for (let FileIndex in AllFiles) {
              let oFileDetail: FileDetail = null;
              oFileDetail = new FileDetail();

              oFileDetail.lCustomPropertyDataId = oCustomPropertyData.lCustomPropertyDataId;
              oFileDetail.FilePath = AllFiles[FileIndex];
              oFileDetail.FileName = AllFiles[FileIndex].split(/[/\\]/).pop();
              oCustomPropertyData.FileDetail.push(oFileDetail);

            }

            if (oCustomPropertyData.lCustomPropertyValueId > 0) {
              oCustomPropertyData.EntityState = 2;
            }
            else {
              oCustomPropertyData.EntityState = 1;
            }

          }
        )
    }

  }

  private DownLoad(e: any) {
    let FilePath =  this.__oUtilityService.ReplaceSpecialCharacters(this.__oUtilityService.EncryptStringAES(e, Constants.EXTERNALSOURCE_AESKEY))
    window.open( this.getApiUrl + "api/CustomProperty/DownloadFile/"+FilePath, '_blank').focus();
  }

  private DeleteFile(lCustomPropertyDataId: any, FilePath: any) {

    let filePath = this.replaceFilePath(FilePath);

    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);

    oCustomPropertyData.Value = oCustomPropertyData.Value.replace(FilePath + ",", "").replace("," + FilePath, "").replace(FilePath, "");

    let oFileDetail: FileDetail = oCustomPropertyData.FileDetail.find(x => x.FilePath == FilePath);
    oCustomPropertyData.FileDetail.splice(oCustomPropertyData.FileDetail.indexOf(oFileDetail), 1);

    if (oCustomPropertyData.Value.trim() == "") {
      oCustomPropertyData.Value = null;
      oCustomPropertyData.FileDetail = [];
    }

    if (oCustomPropertyData.lCustomPropertyValueId > 0) {
      oCustomPropertyData.EntityState = 2;
    }
    else {
      oCustomPropertyData.EntityState = 1;
    }
  }

  private ReferenceTextBoxLostFocus(lCustomPropertyDataId: any) {
    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);
    oCustomPropertyData.ReferenceDataTextBoxVisible = 0;
    oCustomPropertyData.ReferenceDataURLVisible = 1;
    this.defaultValueChanged.emit(true);
  }

  private OpenReferenceDataURL(lCustomPropertyDataId: any) {
    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);

    //let sInstance: string = this.URLEncode(oCustomPropertyData.Value);
    window.open(oCustomPropertyData.Value, "_blank");

  }

  private copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  private EditReferenceData(lCustomPropertyDataId: any) {
    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.lCustomPropertyDataId == lCustomPropertyDataId);
    oCustomPropertyData.ReferenceDataTextBoxVisible = 1;
    oCustomPropertyData.ReferenceDataURLVisible = 0;

    if (oCustomPropertyData.lCustomPropertyValueId > 0) {
      oCustomPropertyData.EntityState = 2;
    }
    else {
      oCustomPropertyData.EntityState = 1;
    }

  }


  /// Common functions

  private replaceAll(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'backslaaash')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101'); //.replace(/\\n/g, 'newline').replace(/\\r/g, 'newline').replace(/\\t/g, 'newline');
    return strToBeReturned;
  }

  private replaceFilePath(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/\\/g, 'bckwrdslsh101').replace(/:/g, 'cln100');
    return strToBeReturned;
  }

  private URLEncode(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/&/g, '%26');
    return strToBeReturned;
  }


  private AddTodayButtonClicked(e: any,DataCaption: string) {
    let oCustomPropertyData: CustomPropertyData = this.__oCustomPropertyData.find(x => x.CustomProperty == DataCaption);
    oCustomPropertyData.Value = new Date();
    if (!this.__oUtilityService.IsNullOrUndefined(e.element)) {
      if (!this.__oUtilityService.IsNullOrUndefined(e.element.className)) {
        e.element.className = "dx-widget dx-button dx-button-mode-contained dx-button-default dx-button-has-text dx-state-active";
      }
    }
  }
  //fires on segregated entity change
  public onSelectionChanged(event: any) {
    if (event?.selectedItem) {
      this.__oCustomPropertyData = this.__oCustomPropertySegregatedData.filter(x => (x.lTradingEntityId === this.__oEntity.lTradingEntityId) && x.lDataInstanceId === this.__oEntity.lTradingCounterpartyId).filter((thing, i, arr) => arr.findIndex(t => t.lCustomPropertyId === thing.lCustomPropertyId) === i);
      this.formSources(this.__oEntity.lTradingCounterpartyId)
    }
  }
}
